module.exports = __webpack_public_path__ + "img/boat_stopped.43e77da3.svg";